import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface WarningIndicatorRendererParams extends ICellRendererParams {
  warningField?: string;
  hasWarning?: boolean;
}

@Component({
  selector: 'lib-warning-indicator-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-indicator-cell-renderer.component.html',
  styleUrls: ['./warning-indicator-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningIndicatorCellRenderer implements ICellRendererAngularComp {
  readonly value = signal<string | number | null | undefined>(
    undefined
  );
  readonly hasWarning = signal(false);

  agInit(params: ICellRendererParams): void {
    this.setValues(params as WarningIndicatorRendererParams);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValues(params as WarningIndicatorRendererParams);
    return true;
  }

  private setValues(params: WarningIndicatorRendererParams): void {
    // Resolve display value
    const displayValue = params.valueFormatted ?? params.value ?? '';
    this.value.set(displayValue);

    // Determine warning state
    const rendererParams = params.colDef?.cellRendererParams || {};
    const warningField = rendererParams.warningField || 'hasWarning';

    let hasWarning = false;

    // Check if warning directly provided in params
    if ('hasWarning' in rendererParams) {
      hasWarning = Boolean(rendererParams.hasWarning);
    }
    // Check if warning field exists in row data
    else if (params.data && warningField in params.data) {
      hasWarning = Boolean(params.data[warningField]);
    }

    this.hasWarning.set(hasWarning);
  }
}
